export default {
    methods: {
        trans(key, replace = {}) {
            if (key) {
                let segments = key.split('::');
                let namespace = segments[0];
                key = segments[1];
                let translation = key.split('.').reduce((t, i) => t[i] || null, window.locale[namespace]);

                for (var placeholder in replace) {
                    translation = translation.replace(`:${placeholder}`, replace[placeholder]);
                }

                return translation;
            }

            return key;
        },

        trans_choice(key, count, replace = {}) {
            if (key) {
                let segments = key.split('::');
                let namespace = segments[0];
                key = segments[1];
                let translation = key.split('.').reduce((t, i) => t[i] || null, window.locale[namespace]).split('|');

                translation = count > 1 ? translation[1] : translation[0];

                for (var placeholder in replace) {
                    translation = translation.replace(`:${placeholder}`, replace[placeholder]);
                }

                return translation;
            }

            return key;
        },

        __(key, replace = {}) {
            return this.trans(key, replace);
        },
    }
}

